export const INPUT_STATE_DEFAULT = 'default';
export const INPUT_STATE_VALID = 'valid';
export const INPUT_STATE_ERROR = 'error';
export const INPUT_STATE_DISABLED = 'disabled';
